import L from "leaflet";
import "leaflet-routing-machine";


export const routingCreateControl = (startLocation, endLocation) => {
    if (!startLocation || !endLocation || !startLocation.latitude || !endLocation.latitude) {
        return { addTo: () => null, spliceWaypoints: () => {} };
    }
    return L.Routing.control({
    waypoints: [
        L.latLng(startLocation.latitude, startLocation.longitude),
        L.latLng(endLocation.latitude, endLocation.longitude),
    ],
    language: "ru",
    draggableWaypoints: false,
    routeWhileDragging: false,
    fitSelectedRoutes: true,
    addWaypoints: false,
    show: false,
    lineOptions: {
        styles: [{color: "rgb(0, 136, 204)", opacity: 0.8, weight: 4}],
    },
    router: new L.Routing.OSRMv1({
        serviceUrl: "/route/v1",
        routingOptions: {
            alternatives: false,
            steps: false,
        },
        useHints: false,
    }),
    createMarker: function () {
        return null;
    },
})
}
